module.exports = __webpack_public_path__ + "img/i.28bc6c82.svg";